export default __webpack_public_path__ + "static/media/1B.3cb98976.png";